/* eslint-disable import/prefer-default-export */
import { put } from 'redux-saga/effects';
// import { dispatchFBNetworkLogs } from '../index';
import UTIL from '../../util';

export function* callAPIMain(payload, actionType, apiHandlerName: Function) {
  const startTime = new Date().getTime();
  try {
    console.info('sending request', actionType, new Date().getTime() - startTime, payload);
    const response = yield apiHandlerName(payload);
    console.info(
      actionType,
      'response time',
      new Date().getTime() - startTime,
      'response',
      response,
    );
    yield put({
      type: `${actionType}_SUCCESS`,
      payload: response.data,
    });
    // const { responseURL } = response.request;
    // dispatchFBNetworkLogs({ responseURL, payload, response: response.data, status: 'SUCCESS' });
  } catch (error) {
    console.warn(`error ${actionType}`, error, error.response);
    const tempPayload = UTIL.errorHandling(error);
    yield put({
      type: `${actionType}_FAILURE`,
      payload: tempPayload,
    });
    // const { request } = error.response;
    // const { responseURL, response } = request;
    // dispatchFBNetworkLogs({ responseURL, payload, response, status: 'FAILURE' });
  }
}

export function* callAPI(payload, actionType, apiHandlerName: Function, hasLocation = true) {
  if (hasLocation) {
    try {
      const location = UTIL.location;
      if (location) {
        const { latitude, longitude } = location;
        const requestBody = {
          ...payload,
          longitude,
          latitude,
          geoLocation: `${latitude},${longitude}`,
        };
        yield callAPIMain(requestBody, actionType, apiHandlerName);
      }
    } catch (error) {
      console.warn(`error ${actionType}`, error);
      const tempPayload = UTIL.errorHandling(error);
      yield put({
        type: `${actionType}_FAILURE`,
        payload: tempPayload,
      });
    }
  } else {
    yield callAPIMain(payload, actionType, apiHandlerName);
  }
}
